module.exports = __webpack_public_path__ + "img/scene_2.e9f6f63d.jpg";